import React from 'react';
import {default as badge} from '../../../images/eco-alliance-badge.svg';
import CommunityImg from '../CommunityImg/CommunityImg';
import { useStaticQuery, graphql } from "gatsby"
import './SustainabilityOurJourney.scss';

const SustainabilityOurJourney = ({
  colorCode
}) => {

  const blogsList = useStaticQuery(graphql`
    query MyQuery {
      OurJourneyPosts: allGhostPost(
        filter: {tags: {elemMatch: {slug: {in: ["our-journey", "hash-ourjourney"]}}}}
        sort: {order: DESC, fields: [published_at]}
        limit: 1000
        skip: 0
      ) {
        edges {
          node {
            id
            title
            slug
            feature_image
            excerpt
            published_at(formatString: "MMMM YYYY")
            primary_author {
              name
              slug
              profile_image
            }
            tags {
              name
              slug
            }
          }
        }
      }
    }
  `);

  // const blogsList = useOurJourney();
  const {edges} = blogsList?.OurJourneyPosts;
  const blogs = edges;

  const openBlog = (slug) => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');

  return (
    <div className="noissue__eco-alliance__sustainability__page__container__tabs__eco-community">
      <div className="eco-community-content">
        noissue is on a mission to make sustainable packaging accessible to businesses, brands and makers no matter their size and to reduce waste by offering packaging that is reusable, compostable or made from recycled materials. 
      </div>
      <div className="eco-community-community-blocks-list" style={blogs.length < 4 ? {justifyContent: 'center'} : {}}>
        {
          blogs.map((item, idx) => {
            return <div className="eco-community-community-blocks-item" key={idx}>
              <div className="eco-community-community-blocks-date" style={{color: colorCode}}>{item.node.published_at}</div>
              <div className="eco-community-community-blocks">
                  <CommunityImg 
                    role="presentation" 
                    className="eco-community-community-blocks-image" 
                    onClick={()=>openBlog(item.node.slug)} 
                    src={item.node.feature_image} 
                    alt="community blog" 
                    loading="lazy"
                  />
                  <div className="eco-community-community-blocks-title" style={{color: colorCode}}>
                    {item.node.title}
                  </div>
                  <div className="eco-community-community-blocks-details">
                    {item.node.excerpt}
                  </div>
                  <div className="eco-community-community-blocks-read-more" style={{color: colorCode}} role="presentation"  onClick={()=>openBlog(item.node.slug)}>Read More</div>
              </div>
            </div>
          })
        }
        <div className="eco-community-community-blocks-empty"></div>
      </div>
    </div>
  )
}

export default SustainabilityOurJourney;